import { Box, type BoxProps } from '../../Box';
import { colorsPalette, styled, theme } from '../../../theme';
import { Container } from './Container';

type PageContainerProps = BoxProps & SectionProps;

/**
 * @deprecated Wrap site contents and house our grid system
 * IMPORTANT: Temporary component please don't use it
 */
export const PageContainer = ({
    children,
    paddingTop = 3,
    paddingBottom = 3,
    ...props
}: PageContainerProps) => (
    <Section {...props} paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Container>{children}</Container>
    </Section>
);

interface SectionProps {
    kind?: 'blue' | 'white' | 'image';
    shadow?: boolean;
    hero?: boolean;
}

const Section = styled(Box, {
    shouldForwardProp: (name: string) => ['kind', 'shadow', 'hero'].includes(name) === false,
})<SectionProps>(({ kind, shadow, hero }) => ({
    width: '100%',
    flex: '1 0 auto',
    position: 'relative',
    backgroundColor: 'transparent',
    ...(kind && kindStyles[kind]),
    ...(shadow && { boxShadow: '0 5px 0 0 #fff, 0 0 5px 0 rgba(0, 0, 0, 0.5)' }),
    ...(hero && { background: 'transparent' }),
}));

const kindStyles = {
    blue: {
        // will be deprecated in near future
    },
    white: {
        background: '#fff',
    },
    image: {
        background: colorsPalette.darkblueSolid[100],
        color: theme.palette.common.white,
        padding: theme.spacing(4, 2),
    },
} as const;
